/* @flow */
// typecheck: ignore file
import React from 'react';
import Input from 'components/Input.jsx';
import { bindActionCreators } from 'redux';
import { setQuery } from 'reducers/tables';
import { connect } from 'react-redux';
import { debounce } from 'lodash';

type Props = {
  setQuery: (namespace: string, query: string) => any,
}

import './styles/SmartTableSearchInput.scss';

class SmartTableSearchInput extends React.Component {
  props: Props;

  static contextTypes = {
    namespace: React.PropTypes.string.isRequired,
  };

  debouncedChangeQuery = debounce((query: string) => this.props.setQuery(this.context.namespace, query), 400)

  onChange = (e) => {
    this.debouncedChangeQuery(e.target.value);
  }

  render() {
    return (
      <div className="SmartTableSearchInput">
        <Input
          size="large"
          placeholder="Search"
          onChange={this.onChange}
          className="SmartTableSearchInput-input"
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ setQuery }, dispatch);
}

export default connect(null, mapDispatchToProps)(SmartTableSearchInput);



// WEBPACK FOOTER //
// ./src/components/SmartTableSearchInput.jsx